import { ServiceTimePerStop } from "../../../models";

// Wire shape of the `service_time_per_stop` setting value (backend snake_case).
export interface RawServiceTime {
  delivery: number;
  pickup: number;
  dump_yard: number;
  storage: number;
}

// Maps the backend snake_case `dump_yard` to the model's `dumpYard`; the other
// three fields pass through. Operates on the bare setting value — the datasource
// unwraps the `{ unit, value }` envelope via getSetting/putSetting.
export function getServiceTime(raw: RawServiceTime): ServiceTimePerStop {
  return {
    delivery: raw.delivery,
    pickup: raw.pickup,
    dumpYard: raw.dump_yard,
    storage: raw.storage,
  };
}
